// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-new-customership-js": () => import("./../src/templates/new-customership.js" /* webpackChunkName: "component---src-templates-new-customership-js" */)
}

